import React, {useState, useEffect} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faPhone} from '@fortawesome/free-solid-svg-icons';
import { faPerson, faPersonDress, faXmark, faCheck } from '@fortawesome/free-solid-svg-icons';

function Tenancy_booking({setTenancybooking}) {
        const [name, setName] = useState('')
        const [schoolname, setSchoolname] = useState('')
        const [schoollocation, setSchoollocation] = useState('')
        const [phone, setPhone] = useState('')
        const [altphone, setAltphone] = useState('')
    
        const [tenancytype, setTenancytype] = useState('')
        const [examduration, setTexamduration] = useState('')
        const [eventperion, setTeventperiod] = useState('')
        const [bnb, setBnb] = useState('')
        const [date, setDate] = useState('')
        const [location, setLocation] = useState('')

        const [loading, setLoading] = useState(false)

        const S_R = () =>{
          setTenancytype('Single Room')
        }
       
        const premium = () =>{
            setTenancytype('Bed Sitter')
        }

        const one_b = () =>{
            setTenancytype('1 bedroom')
        }

        const two_b = () =>{
            setTenancytype('two bedroom')
        }

        const three_b = () =>{
            setTenancytype('three bedroom')
        }

        const three_b_plus = () =>{
            setTenancytype('three bedroom plus')
        }

        const check_TT = () =>{
           setTenancytype('')
        }

  
           const scroll = () =>{
            if (tenancytype==''||phone==''||altphone==''||date==''||location==''||name=='') {
            
                if(tenancytype=='')alert('please pick a tenancy type')

                if(altphone=='') alert('please add your school alternative phone number')
                
                if(phone=='') alert('please add your phone number')

                if(date=='') alert('please add expected date')

                if(location=='') alert('please add location')

                if(name=='') alert('please add your name')

            } else {
                setLoading(true)
                fetch('https://hosteladventures.site/PHP/Booking/tenancy_booking.php', {
                   method: 'POST',
                   headers: {
                     'Content-Type': 'application/json'
                   },
                   body: JSON.stringify({
                      phone,
                      altphone,
                      tenancytype,
                      date,
                      location,
                      name
                   })
                 })
                   .then(response => response.json())
                   .then(data => {
                     // Handle response from backend (e.g., login success or failure)
                     if(data.message=='in')
                     {
                       setLoading(false)
                       alert('Thank you for booking with us, we will contact you within the next 24 hours')
                       setTenancybooking(false)
                     }
     
                    
                  
                   })
                   .catch(error => {
                     console.error('Error:', error);
                     alert('Error Uploading!! Check internet connection!!')
                     setLoading(false)
                   });
            }
        }
       return (
       <div className='Form_HBK'>
                <p className='fill_In'>Tenancy Booking</p>
                <div>
                    <p className='Book_STD'>Tenancy Type?</p>
                    {tenancytype==''?( <div className='Book_STD_BTNS'>
                      <div onClick={S_R} className='Book_std_inner_BTN'>Single Room</div>
                       <div onClick={premium} className='Book_std_inner_BTN'>Bed sitter</div>
                       <div onClick={one_b} className='Book_std_inner_BTN'>1 Bedroom</div>
                       <div onClick={two_b} className='Book_std_inner_BTN'>2 Bedroom</div>
                       <div onClick={three_b} className='Book_std_inner_BTN'>3 Bed Room</div>
                       <div onClick={three_b_plus} className='Book_std_inner_BTN'>More Than 3 Room</div>
                       
                    </div>):(<div><button onClick={check_TT}><FontAwesomeIcon icon={faCheck} /></button></div>)}
                   
                </div>
    
        

                <input placeholder='Tenant Name' onChange={(event) => setName(event.target.value)} />
                <input placeholder='Interested Location' onChange={(event) => setLocation(event.target.value)} />
                <input placeholder='Phone Number' onChange={(event) => setPhone(event.target.value)}/>
                <input placeholder='Aternative Phone Number' onChange={(event) => setAltphone(event.target.value)} />
                <div>
                <div className='DOM_PH'>Expected Reporting Date:</div>
                  <input type='date' placeholder='date of admission' onChange={(event) => setDate(event.target.value)} />
                </div>
               
               {!loading?(<div className='submit' onClick={scroll}>Submit</div>):(<div className='submit'>Loading...</div>)}
                
                
            </div>
  )
}

export default Tenancy_booking